var exports = {
  "kL": "x31de4314--23eeb8--container",
  "nf": "x31de4314--23eeb8--link",
  "VH": "x31de4314--23eeb8--preview",
  "WM": "x31de4314--23eeb8--price-group",
  "q9": "x31de4314--23eeb8--price",
  "Qs": "x31de4314--23eeb8--content",
  "hl": "x31de4314--23eeb8--address",
  "O7": "x31de4314--23eeb8--link-newbuilding",
};

module.exports = exports;
